import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class CookiesConsentService {
  showBanner: boolean = false;
  constructor() {}
  initCookiesConsent(): void {
    const consent = localStorage.getItem("clairtyAnalyticsConsent");
    if (consent === null) {
      console.log("No consent found, showing banner");

      this.showBanner = true;
    } else if (consent === "true") {
      this.startClarity();
    }
  }
  acceptCookies(): void {
    localStorage.setItem("clairtyAnalyticsConsent", "true");
    this.showBanner = false;
    this.startClarity();
  }

  rejectCookies(): void {
    localStorage.setItem("clairtyAnalyticsConsent", "false");
    this.showBanner = false;
  }
  getConsentStatus(): boolean {
    const consent = localStorage.getItem("clairtyAnalyticsConsent");
    if (consent == null) {
      return true;
    }
    return consent === "true";
  }

  private startClarity(): void {
    // Microsoft Clarity snippet
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function (...args: any[]) {
          (c[a].q = c[a].q || []).push(args);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "ufmrmygmg8");

    // Explicit consent signal
    (window as any).clarity("consent");
  }
  withdrawConsent(): void {
    localStorage.setItem("analyticsConsent", "false");
    const clarityScript = document.querySelector('script[src*="clarity.ms"]');
    if (clarityScript) {
      clarityScript.remove();
    }

    delete (window as any).clarity;
  }
}
